import React from 'react'
import {
  groupBy, map, sortBy, sumBy, filter, keys, fromPairs, sum, isObject} from 'lodash'

import { CVECoverageDetails, DemoCoverageDetails, DefaultCoverageDetails, AntiVirusCell, PatchingCell, AntiVirusDetails, PatchingDetails, SummaryCell } from './Cells'
import { CoverageCellAttributes } from './CoverageDefaults'

const generateCoverageSummaryValue = (data, field, detailsFunction = DefaultCoverageDetails) => {
  let firstValue = data.devices[0][field]
  let dataToSort = []
  if (isObject(firstValue)) {
    const deviceKeys = keys(firstValue)
    const dataToPercentize = fromPairs(map(deviceKeys, key => [key, sum(map(data.devices, device => device[field][key]))]))
    dataToSort = map(dataToPercentize, (value, key) => ({ ...detailsFunction(key), count: value }))
  } else {
    dataToSort = map(groupBy(data.devices, field), (devices, status) => ({ ...detailsFunction(status), count: devices.length }))
  }

  return sortBy(dataToSort, 'color')
}

const ComplianceColumn = ({ Header, field, Details, Cell  = SummaryCell }) => ({
  Header, id: field,
  style: { background: '#F2F2F2', alignSelf: 'center' }, Cell, type: 'number',
  accessor: (data) => generateCoverageSummaryValue(data, field, Details),
})

const nonNotApplicable = (statuses) => filter(statuses, (status) => status.color != 'grey')
const sortCoverageSummary = (a, b) => {
  const aPercentageCovered = (sumBy(filter(a, ['color', 'green']), 'count') / sumBy(nonNotApplicable(a), 'count')) * 100
  const bPercentageCovered = (sumBy(filter(b, ['color', 'green']), 'count') / sumBy(nonNotApplicable(b), 'count')) * 100

  if (aPercentageCovered === bPercentageCovered) { return 0 }
  return aPercentageCovered > bPercentageCovered ? 1 : -1
}

const deviceColumns = ({ showMoreDetails }) => [
  { Header: 'Device', accessor: 'name', Cell: (row) => (
    <div style={{ cursor: 'pointer' }} className='link-primary text-decoration-underline' onClick={() => showMoreDetails({ show: true, device: row.original })}>
      {row.value}
    </div>
  ) },
  { Header: 'Last Logged In User', accessor: 'last_logged_in_user' },
  { Header: 'Power', accessor: 'power_state', type: 'powerState', width: 70 },
  { Header: 'Machine Type', accessor: 'machine_type' },
  {
    Header: 'Antivirus',
    accessor: 'antivirus_status',
    width: 130,
    style: { background: '#F2F2F2' },
    Cell: ({ value, original }) => <AntiVirusCell {...{ value, antivirus_product: original.antivirus_product }} />,
  },
  {
    Header: 'Patching',
    accessor: 'patching_status',
    width: 130,
    style: { background: '#F2F2F2' },
    Cell: ({ value }) => <PatchingCell {...{ value }} />,
  },
  CoverageCellAttributes({ Details: DemoCoverageDetails, Header: 'Encryption', accessor: 'encyptionEnabled' }),
  CoverageCellAttributes({ Details: DemoCoverageDetails, Header: 'Password Policy Strength', accessor: 'passwordPolicyStrength' }),
  CoverageCellAttributes({ Details: DemoCoverageDetails, Header: 'Firewall', accessor: 'firewallStatus' }),
  {
    Header: 'CVE',
    accessor: 'cve',
    width: 130,
    style: { background: '#F2F2F2' },
    Cell: ({ value }) => <SummaryCell value={sortBy(map(value, (amount, key) => ({ ...CVECoverageDetails(key), count: amount })), 'color')} />,
  },
]

const customerColumns = () => [
  { Header: 'Customer', accessor: 'customer_name', filterable: true },
  { Header: 'Device Count', accessor: 'devices.length', type: 'number', width: 100 },
  ComplianceColumn({ Header: 'Antivirus', field: 'antivirus_status', Details: AntiVirusDetails }),
  ComplianceColumn({ Header: 'Patching', field: 'patching_status', Details: PatchingDetails }),
  ComplianceColumn({ Header: 'Disk Encryption', field: 'encyptionEnabled', Details: DemoCoverageDetails }),
  ComplianceColumn({ Header: 'Password Policy Strength', field: 'passwordPolicyStrength', Details: DemoCoverageDetails }),
  ComplianceColumn({ Header: 'Firewall', field: 'firewallStatus', Details: DemoCoverageDetails }),
  ComplianceColumn({ Header: 'CVE', field: 'cve', Details: CVECoverageDetails }),
]



export { deviceColumns, customerColumns }
